import { setInteractionError } from '@atlassian/react-ufo/set-interaction-error';
import { AxiosRequestConfig } from 'axios';

import type { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseCartApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';
import { ORDER_LOOKUP_SUBMIT_UFO_NAME } from 'util/ufoNameConstants';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseCartApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    if (remainingPath.includes('?hash=')) {
      setInteractionError(ORDER_LOOKUP_SUBMIT_UFO_NAME, {
        errorMessage: 'mac order lookup submit error',
        name: 'mac order lookup submit error',
      });
    }
    return Promise.reject(error);
  }
};
